module.exports = __webpack_public_path__ + "static/media/Wide Temperatures Icon.d540ac90.png";